module.exports = __webpack_public_path__ + "static/media/head-front.1bbfbc6b.png";